// eslint-disable-next-line import/no-named-as-default
import ArticleGrid from './ArticleGrid';

export default ArticleGrid;
